<div class="combined-nudge-card">
  <div class="nudge-row" (click)="announcementsClick.emit()">
    <div class="nudge-row-icon nudge-row-icon--accent">
      <ptl-icon [icon]="LucideBell" size="s"></ptl-icon>
    </div>
    <div class="nudge-row-content">
      <div class="nudge-row-title">
        {{ announcementCount }}
        {{
          announcementCount === 1
            ? ('translations.programs.detail.announcementSingular' | transloco)
            : ('translations.programs.detail.announcementPlural' | transloco)
        }}
        @if (hasNewAnnouncements) {
          <ptl-base-badge color="accent" size="s" [text]="'translations.programs.detail.new' | transloco"></ptl-base-badge>
        }
      </div>
      @if (latestAnnouncement) {
        <div class="nudge-row-preview">{{ latestAnnouncement.subject }}</div>
      }
    </div>
    <ptl-icon [icon]="LucideArrowRight" size="xs" class="nudge-row-arrow"></ptl-icon>
  </div>
</div>
